export interface UserSessionState {
  userId: string;
  lastAccessedAt: Date;
  currentView: {
    page: 'collections' | 'problems' | 'home';
    collectionId?: string;
    problemId?: string;
    problemIndex?: number;
  };
  uiState: {
    // Only track current expanded sections (not per-problem)
    expandedSections?: {
      description?: boolean;
      algorithm?: boolean;
      code?: boolean;
      walkthrough?: boolean;
      animation?: boolean;
    };
    scrollPosition?: number;
    activeTab?: string;
  };
  preferences: {
    codeLanguage?: string;
    theme?: 'light' | 'dark';
  };
}

export interface SessionStorageManager {
  saveSession: (state: Partial<UserSessionState>) => Promise<void>;
  getSession: () => Promise<UserSessionState | null>;
  clearSession: () => Promise<void>;
  updateSession: (updates: Partial<UserSessionState>) => Promise<void>;
}

export const DEFAULT_SESSION_STATE: Partial<UserSessionState> = {
  currentView: {
    page: 'home'
  },
  uiState: {
    expandedSections: {
      description: true,
      algorithm: false,
      code: false,
      walkthrough: false,
      animation: false
    },
    scrollPosition: 0
  },
  preferences: {
    codeLanguage: 'python',
    theme: 'light'
  }
};